// Links para falar com o contato: WhatsApp (celular) e e-mail
const digitos = (v) => String(v || '').replace(/\D/g, '')

// Primeiro telefone da lista com DDD; devolve só os dígitos (sem o 55)
export function telefonePrincipal(telefones) {
  const lista = String(telefones || '').split(/[,;/|]/).map(digitos).map((t) => t.replace(/^55(?=\d{10,11}$)/, ''))
  return lista.find((t) => t.length === 11 || t.length === 10) || ''
}

// Celular (11 dígitos com 9 na frente do número) abre o WhatsApp; fixo não
export function linkWhatsapp(telefones, texto) {
  const t = telefonePrincipal(telefones)
  if (!(t.length === 11 && t[2] === '9')) return null
  return `https://wa.me/55${t}${texto ? `?text=${encodeURIComponent(texto)}` : ''}`
}

export function linkEmail(email, assunto, corpo) {
  const e = String(email || '').trim()
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)) return null
  const q = [assunto && `subject=${encodeURIComponent(assunto)}`, corpo && `body=${encodeURIComponent(corpo)}`].filter(Boolean).join('&')
  return `mailto:${e}${q ? `?${q}` : ''}`
}

export function linkTelefone(telefones) {
  const t = telefonePrincipal(telefones)
  return t ? `tel:+55${t}` : null
}

// Mensagem com o acesso ao portal do cliente
export function mensagemAcessoPortal({ nome, cpf, senha, escritorio }) {
  const url = `${window.location.origin}/portal-cliente/login`
  return [
    `Olá${nome ? `, ${String(nome).split(' ')[0]}` : ''}!`,
    `Você já pode acompanhar seus processos${escritorio ? ` com ${escritorio}` : ''} pelo Portal do Cliente:`,
    url,
    `Login: seu CPF${cpf ? ` (${cpf})` : ''}`,
    `Senha: ${senha}`,
    'Guarde esta senha. Se esquecer, é só pedir uma nova ao escritório.',
  ].join('\n')
}
